/**  * Created by portiz on 8/15/2018.  */
import React from 'react';
import BarChart from './chart-bar';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * To manage the charts of lesson tries
 */
class ChartLessonTries extends React.Component {
    constructor(props) {
        // Super is always called when defining the constructor of a subclass 
        //  All React component classes that have a constructor, should start it with a super(props) call. 
        super(props);
        this.state = {
            languages: this.props.data.languages,
            triesChartData: this.props.data.triesChartData
        };
    }

    /** 
     * Sets the chart data 
     */
    setData() {
        this.setState({triesChartData: this.state.triesChartData});
    }

    /** 
     *  Called on the first time  to set the data
     */
    componentWillMount() {
        this.setData();
    }

    /**
     * Renders the bar chart
     * @returns {XML}
     */
    renderItem() {
        return <BarChart redraw data={this.state} refresh={this.state}/>;
    };

    /**
     * Call when updated
     * @param props
     */
    componentWillReceiveProps(props){
        this.props = props;
        // Update data
        this.setState({triesChartData:this.props.data.triesChartData},()=>{
            this.setData();
        });
    }

    /**
     * Renders the component
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <h3><Translate id="report-student-average.student-tries"/></h3>
                <div className="tries-chart-row">
                    {this.renderItem(this.state.triesChartData)}
                </div>
            </div>
        )
    };

}
export default ChartLessonTries;